import { create } from 'zustand'
import Cookies from 'js-cookie'

const CONSENT_COOKIE_KEY = 'nobrinde-cookie-consent'

export type CookieConsentStatus = 'pending' | 'accepted' | 'rejected'

interface CookieConsentState {
  status: CookieConsentStatus
  setStatus: (status: 'accepted' | 'rejected') => void
}

export const useCookieConsentStore = create<CookieConsentState>((set) => {
  const stored = Cookies.get(CONSENT_COOKIE_KEY)
  const status: CookieConsentStatus = stored === 'accepted' || stored === 'rejected' ? stored : 'pending'

  return {
    status,
    setStatus: (status) => {
      Cookies.set(CONSENT_COOKIE_KEY, status, { expires: 180 })
      set({ status })
    },
  }
})
